import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { spacing4, spacing8, spacing16, grey15 } from "@churchofjesuschrist/eden-style-constants";
import { jsx as _jsx } from "react/jsx-runtime";
const StyledFooter = styled.footer.withConfig({
  componentId: "sc-1ccsyeu-0"
})(["border-block-start:1px solid ", ";padding:calc(", " + ", ") ", ";"], grey15, spacing8, spacing4, spacing16);

/**
 * Use a footer to stick content at the bottom of the contextual menu.
 */
const Footer = _ref => {
  let {
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/_jsx(StyledFooter, {
    ...props,
    children: children
  });
};
Footer.propTypes = {
  /** Content inside the footer */
  children: PropTypes.node.isRequired
};
export default Footer;